import axios from "axios";
import { Apis, BaseUrl } from "../../config";

import { getSession } from "../authActions";
import { toast } from "react-toastify";

export const payoutList = (startDate, endDate) => async (dispatch) => {
  const { token, user_profile_id, role_id } = getSession();

  dispatch({ type: "payout_List_req" });
  try {
    const response = await axios.get(
      `${BaseUrl}${Apis.payoutlist}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          sys_user_id: user_profile_id,
          role_id: role_id,
          startDate: startDate,
          endDate: endDate
        }

      },

    );
    dispatch({ type: "payout_List_Success", payload: response.data });

  } catch (error) {
    dispatch({
      type: "payout_List_failure",
      payload: error.response.data,
    });

    toast.error(error?.response?.data?.usr?.message);
  }
};


export const createPayout = (values) => async (dispatch) => {
  const { token, user_profile_id, role_id } = getSession();
  values.sys_user_id = user_profile_id;
  values.role_id = role_id;
  dispatch({ type: "add_payout_req" });
  try {
    const response = await axios.post(`${BaseUrl}${Apis.payout}`, values, { // Update API endpoint as needed
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch({ type: "add_payout_success", payload: response.data });

    toast.success(response.data.usr.message);
  } catch (error) {
    dispatch({
      type: "add_payout_failure",
      payload: error.response.data.usr.message,
    });

    toast.error(error.response.data.usr.message);
  }
};

export const payoutFileList = () => async (dispatch) => {
  const { token, user_profile_id, role_id } = getSession();

  dispatch({ type: "payout_FileList_req" });
  try {
    const response = await axios.get(
      `${BaseUrl}${Apis.payoutFiles}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          sys_user_id: user_profile_id,
          role_id: role_id,
        }

      },

    );
    dispatch({ type: "payout_FileList_Success", payload: response.data });

  } catch (error) {
    dispatch({
      type: "payout_FileList_failure",
      payload: error.response.data,
    });

    toast.error(error?.response?.data?.usr?.message);
  }
};

export const updatePayoutFile = (fileId, fileName) => async (dispatch) => {
  const { token, user_profile_id, role_id } = getSession();
  const values = {sys_user_id :user_profile_id, role_id: role_id, svcf_id: fileId, svcf_filename: fileName};
  
  dispatch({ type: "upd_payoutFiles_req" });
  try {
    const response = await axios.put(`${BaseUrl}${Apis.payoutFiles}${fileId}`, values, { // Update API endpoint as needed
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    dispatch({ type: "upd_payoutFiles_success", payload: response.data });

    toast.success(response.data.usr.message);
  } catch (error) {
    dispatch({
      type: "upd_payoutFiles_failure",
      payload: error.response.data.usr.message,
    });

    toast.error(error.response.data.usr.message);
  }
};

export const downloadPayoutFile = (fileId, fileName) => async (dispatch) => {
  const { token, user_profile_id, role_id } = getSession();
  const values = {sys_user_id :user_profile_id, role_id: role_id, svcf_id: fileId, svcf_filename: fileName};
  
  dispatch({ type: "upd_payoutFiles_req2" });
  try {
    const response = await axios.put(`${BaseUrl}${Apis.payoutFiles}${fileId}`, values, { // Update API endpoint as needed
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    dispatch({ type: "upd_payoutFiles_success2", payload: response.data });

    toast.success(response.data.usr.message);
  } catch (error) {
    dispatch({
      type: "upd_payoutFiles_failure",
      payload: error.response.data.usr.message,
    });

    toast.error(error.response.data.usr.message);
  }
};